// src/components/layout/Footer.tsx
"use client";
import { useTranslations } from 'next-intl';
import Image from "next/image";
import Link from "next/link";

const locationSVG = () => {
  return (
    <svg height="15px" width="15px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32.001 32.001">
      <g>
        <g id="map_x5F_pin_x5F_stroke">
          <g>
            <path style={{ fill: '#a684ff' }} d="M15.997,4c1.605,0,3.113,0.625,4.246,1.76C21.375,6.891,22,8.398,22,10s-0.625,3.109-1.73,4.213
                          c-0.168,0.166-2.238,2.225-4.273,5.441c-2.02-3.211-4.082-5.262-4.238-5.414C10.625,13.109,10,11.602,10,10
                          s0.625-3.109,1.758-4.242S14.314,4,15.997,4 M15.997,0c-2.555,0-5.113,0.977-7.066,2.93c-3.906,3.904-3.906,10.236,0,14.141
                          c0,0,7.066,6.93,7.066,14.93c0-8,7.074-14.93,7.074-14.93c3.906-3.904,3.906-10.236,0-14.141C21.118,0.977,18.559,0,15.997,0
                          L15.997,0z"/>
            <path style={{ fill: '#a684ff' }} d="M18,10c0,1.105-0.895,2-2.004,2C14.811,12,14,11.105,14,10s0.811-2,1.996-2
				                  C17.105,8,18,8.895,18,10z"/>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default function Footer() {
  const t = useTranslations('Footer');
  const title = t('ready_push_limits');
  const words = title.split(" ");

  return (
    <footer className="w-full bg-gray-50 border-t border-gray-200 mt-0 pt-16 relative">
      <div className="mx-auto py-10 grid grid-cols-1 px-5 md:px-20">
        <div className="col-span-1">
          <h2 className="text-2xl md:text-6xl font-light text-gray-800 mb-4">
            {words[0]}{" "}{words[1]}{" "} <br />
            {words.slice(2).join(" ")}
          </h2>
          <h3 className='flex mt-6 gap-2 underline text-lg md:text-xl items-center cursor-pointer'>
            <Link href="/contact-us" className="hover:text-primary color-black">{t('contact_us')}</Link>
            {/* <ArrowRight className="w-8 h-8 border-1 rounded-full px-2 hidden md:block transition-transform group-hover:hidden" /> */}
          </h3>
        </div>
        contact@primalt.com
      </div>
      <div className="mx-auto px-5 md:px-20 py-10 grid grid-cols-1 md:grid-cols-3 gap-8">
        <nav className="col-span-2 grid grid-cols-3 gap-6 text-sm">
          <div>
            <h3 className="font-semibold text-gray-700 mb-3">{t('say_hello')}</h3>
            <div>
              PRIMALT INTERNATIONAL<br />
              <h4 className='flex gap-1 items-center'>{locationSVG()} Zebbug, Malta</h4>
              <h4 className='flex gap-1 items-center'>{locationSVG()} New York, United States</h4>
              <h4 className='flex gap-1 items-center'>{locationSVG()} Tirana, Albania</h4>
            </div>
          </div>
          <div>
            <h3 className="font-semibold text-gray-700 mb-3">{t('sitemap')}</h3>
            <ul className="space-y-2">
              <li><Link href="/" className="hover:text-primary color-black">{t('home')}</Link></li>
              <li><Link href="/about-us" className="hover:text-primary color-black">{t('about')}</Link></li>
              <li><Link href="/services" className="hover:text-primary color-black">{t('services')}</Link></li>
              <li><Link href="/projects" className="hover:text-primary color-black">{t('projects')}</Link></li>
              <li><Link href="/blog" className="hover:text-primary color-black">{t('blogs')}</Link></li>
            </ul>
          </div>
          <div>
            <h3 className="font-semibold text-gray-700 mb-3">Primalt</h3>
            <ul className="space-y-2">
              <li><Link href="/contact-us" className="hover:text-primary color-black">{t('contact_us')}</Link></li>
              <li><Link href="/terms-conditions" className="hover:text-primary color-black">Terms & Conditions</Link></li>
              <li><Link href="/privacy-policy" className="hover:text-primary color-black">Privacy Policy</Link></li>
            </ul>
          </div>
          {/* <div>
            <h3 className="font-semibold text-gray-700 mb-3">PRIMALT</h3>
            <h4 className=''>
              {t('about_subtitle')}
            </h4>
          </div> */}
        </nav>

        {/* Right Section - Logo/Icon */}
        <div className="flex items-start justify-start hidden md:block">
          <Image
            src="/images/primalt-fire.png"
            alt="Primalt Fire Icon Footer"
            width={400}
            height={400}
            className="rounded-full absolute top-10 right-30"
            loading="lazy"
          />
        </div>
      </div>

      {/* Bottom Copyright */}
      <div className="border-b-violet-400 border-b-10 text-start py-2 px-4 text-sm text-gray-500">
        ©Primalt {new Date().getFullYear()}{"  "} {t('website_made_by')} Primalt
      </div>
    </footer>
  );
}
